import BasePage from '@/found/components/table_page';

export default {
  name: 'marketing_promote_detail_list',
  extends: BasePage,
  data() {
    return {
      params: {
        actType: 'promotion',
      },
    };
  },
  components: {

  },
  async created() {
    await this.getConfigList('marketing_promote_detail_list');
  },
  methods: {

  },
};
